import { createApp, h } from 'vue'
import MusicPlayer from './src/musicPlayer.vue' // Vue 3 通常使用.vue文件

const myMusicPlayer = (props) => {
  // 创建一个临时的div作为挂载点
  const container = document.createElement('div')
  document.body.appendChild(container)
  
  let instance = null
  
  // 创建Vue应用实例
  const app = createApp({
    render() {
      return h(MusicPlayer, {
        ...props,
        ref: (ref) => { instance = ref }, // 获取组件实例
        onClose: () => {
          app.unmount() // 卸载应用
          document.body.removeChild(container) // 移除DOM元素
        }
      })
    }
  })
  
  // 挂载到临时容器
  app.mount(container)
  
  return instance
}

export default myMusicPlayer